export default {
  "common.brand": "US Fans Spreadsheet",
  "common.tagline": "Ressource indépendante de merch pour fans",
  "common.buyNow": "Acheter maintenant",
  "common.visitStore": "Visiter la boutique",
  "common.guide": "Guide",
  "common.home": "Accueil",
  "common.shoppingGuide": "Guide d'achat",
  "common.menu": "Menu",
  "common.selectCategory": "Choisissez une catégorie…",
  "common.browseCategories": "Parcourir les catégories",
  "common.readMore": "Lire la suite",
  "common.external": "S'ouvre dans un nouvel onglet",
  "common.backHome": "Retour à l'accueil",
  "lang.en": "English",
  "lang.es": "Español",
  "lang.fr": "Français",
  "lang.pl": "Polski",
  "footer.tagline": "Un hub indépendant qui organise le merch pour fans en catégories faciles à parcourir.",
  "footer.resources": "Ressources",
  "footer.categories": "Catégories",
  "footer.guide": "Guide du merch pour fans",
  "footer.visitStore": "Visiter la boutique principale",
  "footer.disclaimer": "US Fans Spreadsheet est une ressource informative indépendante et n'est affilié ni soutenu par aucune marque ou équipe officielle.",
  "footer.rights": "Tous droits réservés.",
};